import React from 'react';
import type { ClassMemberGroupMeta } from '../../utils/classMembersStorage';

type Props = {
  groups: ClassMemberGroupMeta[];
  selectedGroupId: string | null;
  onChange: (groupId: string) => void;
  /** 그룹이 많을 때 select 사용 (기본: 탭) */
  preferSelectWhenOver?: number;
};

const NoteGroupSelector: React.FC<Props> = ({
  groups,
  selectedGroupId,
  onChange,
  preferSelectWhenOver = 5,
}) => {
  if (groups.length === 0) {
    return <span className="cp-apn-group-empty">그룹 없음</span>;
  }

  if (groups.length > preferSelectWhenOver) {
    return (
      <label className="cp-apn-group-select-wrap" data-tutorial-apn="group-select">
        <span className="cp-apn-group-select-label">그룹</span>
        <select
          className="cp-apn-group-select"
          value={selectedGroupId ?? ''}
          onChange={(e) => onChange(e.target.value)}
          aria-label="멤버 그룹 선택"
        >
          {groups.map((g) => (
            <option key={g.id} value={g.id}>
              {g.name?.trim() || '그룹'}
            </option>
          ))}
        </select>
      </label>
    );
  }

  return (
    <div
      className="cp-apn-group-tabs"
      role="tablist"
      aria-label="멤버 그룹"
      data-tutorial-apn="group-select"
    >
      {groups.map((g) => {
        const active = g.id === selectedGroupId;
        return (
          <button
            key={g.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`cp-apn-group-tab${active ? ' is-active' : ''}`}
            onClick={() => onChange(g.id)}
          >
            {g.name?.trim() || '그룹'}
          </button>
        );
      })}
    </div>
  );
};

export default NoteGroupSelector;
